import React from 'react';

import { StopCircleIcon } from '@vlabs/icons';
import { Control } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

export const CancelCell = ({
  onCancelHandler,
  row,
}) => {
  const { t } = useTranslation();
  const { original: { task_status } } = row;
  if (![0, 1].includes(task_status)) return null;
  return (
    <div title={t('tasks:confirmation.stop_task.title')}>
      <Control.IconButton
        data-testid="cancelCell"
        icon={<StopCircleIcon />}
        kind="primary"
        onClick={() => onCancelHandler(row.original)}
        variant="dimmed"
      />
    </div>
  );
};
